import React, { useEffect } from "react";
import { connect } from "react-redux";
import Loader from "../../shared/loader";
import {
  fetchUsersByCountry
} from "./ducks/actions";
import Form from "./form";
//import { countries } from "./country-data";

function Register(props) {
  const {
    fetchUsersByCountry,
    loading,
    errors,
    countries
  } = props;

  useEffect(() => {
    fetchUsersByCountry();
  }, []);

  if (loading) {
    return <Loader />;
  }

  const refresh = () => {
    fetchUsersByCountry();
  };

  return (
    <div className="blade-content wideaf">
      <Form
        errors={errors}
        loading={false}
        initialValues={{ countries: countries }}
        countries={countries}
        refresh={refresh}
        {...props}
      />
    </div>
  );
}

function mapStateToProps(state) {
  const { adminState } = state;
  return {
    countries: adminState.adminUsersByCountryState.countries,
    errors: adminState.adminUsersByCountryState.errors,
    loading: adminState.adminUsersByCountryState.loading
  };
}

export default connect(mapStateToProps, {
  fetchUsersByCountry
})(Register);
